import { render } from "./OrderListTabletColumnsSelector.vue?vue&type=template&id=62639c58&scoped=true"
import script from "./OrderListTabletColumnsSelector.vue?vue&type=script&lang=js"
export * from "./OrderListTabletColumnsSelector.vue?vue&type=script&lang=js"

import "./OrderListTabletColumnsSelector.vue?vue&type=style&index=0&id=62639c58&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62639c58"]])

export default __exports__